import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-united-insurance-home',
  templateUrl: './united-insurance-home.component.html',
  styleUrls: ['./united-insurance-home.component.css']
})
export class UnitedInsuranceHomeComponent implements OnInit {

  constructor(private router: Router) { }
  insuranceRights: any;
  ngOnInit() {
    this.insuranceRights = JSON.parse(localStorage.getItem("InsuranceRights"));
  }
  routeToUnitedIssue() {
    this.router.navigateByUrl("united-travel-insurance");
  }
  routeToBooked(id: string) {
    this.router.navigate(['/search-booked-plan', id]);
  }
}
